import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { MarketPlacePersonalizationUtils } from '@app-components/layouts/shopkeeper-layout/marketplace-personalization';
import { EvaluationVehicle } from '@app-model/evaluation';
import { ReportEquipment, Vehicle } from '@app-model/vehicle';
import { OpenService } from '@app-services/open.service';

@Component({
  selector: 'app-card-raio-x-technical',
  templateUrl: './card-raio-x-technical.component.html',
  styleUrls: ['./card-raio-x-technical.component.scss']
})
export class CardRaioXTechnicalComponent implements OnInit {

  @Input() vehicle: EvaluationVehicle;
  @Input() castOffVehicle: Vehicle;

  get data(): Vehicle | EvaluationVehicle | undefined {
    return this.castOffVehicle || this.vehicle;
  }

  reportItemsWithName: any[] = [];
  titleColor: string = 'var(--button-branded4)';
  constructor(
    private elRef: ElementRef,
    private openService: OpenService
  ) {
    this.openService.getLayoutVars().subscribe((layoutVars) => {
      if (layoutVars) {
        this.titleColor = MarketPlacePersonalizationUtils.getColorNotWhite(['offerColor', 'primaryColor', 'buttonColor'], layoutVars);
      }
    });
  }

  ngOnInit(): void {
    this.reportItemsWithName = this.buildReportItemWithName();
  }

  get hasReports(): boolean {
    return this.reportItemsWithName
      .some(item => item.classification !== 'NON_EXISTENT');
  }

  private buildReportItemWithName(): any[] {
    return Object.keys(this.data?.reportItems || {}).map((key) => {
      const item = this.data.reportItems[key];
      return {
        classification: item.classification,
        fixingCost: item.fixingCost,
        photosAndVideosUrls: item.photosAndVideosUrls,
        description: item.description,
        audio: item.audio,
        name: ReportEquipment[key],
      };
    }).filter(item => item.classification !== 'NON_EXISTENT');
  }

}
